import { instagramAuditService } from './instagram/instagramAuditService';
import { InstagramAuditInput } from '../../types/socialMediaAudit';

type Platform = 'instagram' | 'facebook' | 'linkedin' | 'tiktok' | 'youtube' | 'x';

export class SocialMediaAuditFactory {
  
  public static async performAudit(platform: Platform, input: any) {
    switch (platform) {
      case 'instagram':
        return await instagramAuditService.performAudit(input as InstagramAuditInput);
      case 'facebook':
        throw new Error("Facebook audit not yet implemented.");
      case 'linkedin':
        throw new Error("LinkedIn audit not yet implemented.");
      case 'tiktok':
        throw new Error("TikTok audit not yet implemented.");
      case 'youtube':
        throw new Error("YouTube audit not yet implemented.");
      case 'x':
        throw new Error("X (Twitter) audit not yet implemented.");
      default:
        throw new Error(`Platform ${platform} is not supported.`);
    }
  }
}
